<template>
  <v-toolbar dense flat>
    <v-btn icon @click="$emit('close')" class="mr-2"><v-icon>mdi-close</v-icon></v-btn>
    <div class="d-flex align-center">
      <div class="text-no-wrap mr-2">
        <div class="body-1">{{chat.name}}</div>
        <div class="body-2 mt-n1 caption">
          <span v-if="cat!==null">
            <v-icon small class="mr-1" style="margin-top:-1px">{{cat.icon}}</v-icon>
            <span>{{cat.name}}</span>
            <dot v-if="provider!==null || phone!==null || gender!==null || years!==null"/>
          </span>
          <span v-if="provider!==null">
            <span>{{provider}}</span>
            <dot v-if="phone!==null || gender!==null || years!==null"/>
          </span>
          <span v-if="phone!==null">
            <call-phone :phone="phone" small/>
            <dot v-if="gender!==null || years!==null"/>
          </span>
          <span v-if="gender!==null">
            <span>{{gender}}</span>
            <dot v-if="years!==null"/>
          </span>
          <span v-if="years!==null">
            <span>{{years}}</span>
          </span>
        </div>
      </div>
    </div>
    <v-spacer/>
    <div class="overflow-y-auto text-no-wrap full-width text-right">
      <v-btn
          :disabled="clientUser===null"
          @click="$tools.openUrl('/panel/user/'+clientUser.user.type+'/'+clientUser.user.id+'/', true)"
          depressed small class="ml-2"
      >
        Профиль<v-icon dense small class="ml-2">mdi-open-in-new</v-icon>
      </v-btn>
      <v-menu offset-y max-width="300" z-index="10">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs" v-on="on"
              :disabled="client===null || client._userVariants.filter(v=>v.id!==clientUser?.user.id).length===0"
              class="ml-2" depressed
              small
              width="150"
          >
            <v-icon small class="mr-2">mdi-account-edit</v-icon>
            Клиенты {{client===null || client._userVariants.filter(v=>v.id!==clientUser?.user.id).length===0 ? '' : '('+client._userVariants.length+')'}}
          </v-btn>
        </template>
        <v-list v-if="client!==null && client._userVariants.length>1" dense class="pa-0">
          <v-list-item
              v-for="(v, i) in client._userVariants" :key="i"
              class="pa-0"
              :class="clientUser?.id===v.id ? 'v-list-item--active' : ''"
          >
            <v-row no-gutters>
              <v-col cols="12" class="py-2 px-4">
                <div class="body-2">{{$tools.userFullName(v, true)}}</div>
                <div class="body-2 caption">
                  <span>{{v.userProfile.gender==='male' ? 'мужчина' : 'женщина'}}</span><dot/>
                  <span>{{$tools.dateYearsSimple(v.userProfile.birth, 'YYYY-MM-DD HH:mm:ss')}}</span>
                </div>
              </v-col>
              <v-col class="pb-2 px-4">
                <v-btn
                    @click="dialogUserChangeUser(client.id, v.id)"
                    :disabled="clientUser?.user.id===v.id"
                    depressed small class="mr-2"
                >
                  {{clientUser?.user.id===v.id ? 'Выбран' : 'Выбрать'}}
                </v-btn>
                <v-btn @click="$tools.openUrl('/panel/user/'+v.type+'/'+v.id+'/', true)" depressed small>
                  Профиль<v-icon dense small class="ml-2">mdi-open-in-new</v-icon>
                </v-btn>
              </v-col>
              <v-col v-if="i<client._userVariants.length-1" cols="12">
                <v-divider/>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <template v-if="clientUser" v-slot:extension>
      <tag-add :entityId="clientUser.id" entityType="user" sideTitle/>
    </template>
  </v-toolbar>
</template>

<script>
import Dot from "../../../componentsV2/base/Dot.vue";
import CallPhone from "../../../components/CallPhone.vue";
import TagAdd from "../../Tag/components/TagAdd.vue";
import axios from "axios";

export default {
  components: {TagAdd, CallPhone, Dot},
  props: ['cats','chat'],
  data: () => ({
    subscribeListenerId:null,
  }),
  computed:{
    cat(){
      if(this.chat===null) return null;

      let arr = this.cats.filter(v=>v.id===this.chat.cat)
      return arr.length>0 ? arr[0] : null;
    },

    client(){
      if(this.chat===null) return null;

      let arr = this.chat.dialogUsers
          .filter(v=>v.user===null ? true : v.user.id!==this.$store.state.user.id)
          .filter(v=>v.provider!=='internal');
      if(arr.length===1)
        return arr[0];

      return null;
    },

    clientUser(){
      if(this.chat===null) return null;

      let arr = this.chat.dialogUsers
          .filter(v=>v.user===null ? false : v.user.id!==this.$store.state.user.id)
          .filter(v=>v.provider!=='internal');
      if(arr.length===1)
        return arr[0];

      return null;
    },

    provider(){
      if(this.chat===null) return null;

      let b = (str)=>{
        return str
            // добавляем пробел перед заглавными буквами, кроме первой
            .replace(/([A-ZА-ЯЁ])/g, ' $1')
            .trim()
            // первую букву делаем заглавной
            .replace(/^./, char => char.toUpperCase());
      };

      let client = this.client;
      if(client) return b(client.provider);

      return null;
    },

    phone(){
      if(this.chat===null) return null;

      let client = this.client;
      if(client) return client.phone;

      return null;
    },
    gender(){
      if(this.chat===null) return null;

      let clientUser = this.clientUser;
      if(clientUser) return clientUser.user.userProfile.gender==='male' ? 'Мужчина' : 'Женщина';

      return null;
    },
    years(){
      if(this.chat===null) return null;

      let clientUser = this.clientUser;
      if(clientUser){
        let v = this.$tools.dateYearsSimple(clientUser.user.userProfile.birth, 'YYYY-MM-DD')
        return this.$tools.isEmpty(v) ? null : v;
      }

      return null;
    },
  },
  methods:{
    dialogUserChangeUser(dialogUserId, userId){
      axios.put('/napi/dialog/user/', {
        dialogUserId:dialogUserId,
        userId:userId,
      });
    },
  }
}
</script>